const blacklist = {
    firestorePath: '/blacklist',
    firestoreRefType: 'collection',
    moduleName: 'blacklist',
    statePropName: 'blacklist',
    namespaced: true,
    serverChange: {
        convertTimestamps: {
            created_at: '%convertTimestamp%', // default
            updated_at: '%convertTimestamp%', // default
        },
    },
    state: {},
    getters: {
        getBlacklist: (state) => {
            return _.toArray(state.blacklist);
        },
        checkBlacklist: (state) => (lastName, birthdate) => {
            let blacklist = _.toArray(state.blacklist);
            let findBlacklist = _.find(blacklist, {
                'lastName': lastName,
                'birthdate': birthdate,
            });
            return findBlacklist;
        },

    },
    mutations: {},
    actions: {},
}

export default blacklist